export default __webpack_public_path__ + "static/media/Ballroll_00169.728e87e0.png";